/**
 * AB#22138 — when to invite someone to turn on notifications again, per
 * device (it is the device that gets them). "Not now" waits 3 days; from the
 * third "Not now" on, 30.
 */
export const PUSH_PROMPT_KEY = 'push_prompt_v1';
const DAY = 86_400_000;

interface Seen {
  until: number;
  count: number;
}

const read = (storage: Storage | undefined): Seen => {
  try {
    const raw = storage?.getItem(PUSH_PROMPT_KEY);
    const v = raw ? (JSON.parse(raw) as Partial<Seen>) : {};
    return { until: Number(v.until) || 0, count: Number(v.count) || 0 };
  } catch {
    return { until: 0, count: 0 };
  }
};

export const promptDue = (storage: Storage | undefined, now: number): boolean =>
  read(storage).until <= now;

export const rememberLater = (storage: Storage | undefined, now: number): void => {
  const seen = read(storage);
  const count = seen.count + 1;
  try {
    storage?.setItem(
      PUSH_PROMPT_KEY,
      JSON.stringify({ count, until: now + (count >= 3 ? 30 : 3) * DAY })
    );
  } catch {
    // Storage unavailable: it may ask again next visit, which is harmless.
  }
};

/**
 * AB#22138 — the one-time "what's new" note for someone who already has
 * notifications on, when order notifications arrive. Once per device.
 */
export const PUSH_WHATS_NEW_KEY = 'push_whatsnew_orders_v1';

export const whatsNewDue = (storage: Storage | undefined): boolean => {
  try {
    return !storage?.getItem(PUSH_WHATS_NEW_KEY);
  } catch {
    return false;
  }
};

export const rememberWhatsNew = (storage: Storage | undefined, now: number): void => {
  try {
    storage?.setItem(PUSH_WHATS_NEW_KEY, String(now));
  } catch {
    // Storage unavailable: the note may show again, which is harmless.
  }
};
